import { UserTypes } from '@fareye/common'
import { getLocalStorage, getRuntimeUserData } from '@fareye/utils'
import { ConfigType } from './types'

export function stringArrayToLabelValueArray(input: Array<string>) {
  return input
    ? input.map(ele => {
        return {
          label: ele,
          value: ele
        }
      })
    : []
}

//NOTE: Filter any key from array of objects
export function filterKeyFromObject(obj: any[], key: string) {
  if (obj) {
    return obj.map(ele => ele[key])
  } else {
    return null
  }
}

export function getErrorMessage(ex: { response: { data: any } }) {
  let errorMessage
  try {
    const { error } = ex.response.data
    if (Array.isArray(error)) {
      errorMessage = error[0]
    } else {
      errorMessage = error
    }
  } catch (ex:any) {
    errorMessage = 'Something went wrong ...'
  }
  return errorMessage
}

export const schemaGenerator = (j: object) => {
  let tempSchema = {}
  function makeSchema(json: any, schema: any) {
    if (typeof json === 'string') {
      schema['type'] = 'string'
      schema.properties = {}
      schema.required = []
    } else if (typeof json === 'number') {
      schema['type'] = 'string'
      schema.properties = {}
      schema.required = []
    } else if (json === null) {
      schema['type'] = 'null'
    } else if (typeof json === 'object' && Array.isArray(json)) {
      schema['type'] = 'array'
      let bigObject: any = {}
      let prop = json.map(item => typeof item)
      if (prop.includes('object')) {
        json.map(item => {
          Object.entries(item).map(([key, value]) => {
            bigObject[key] = value
          })
        })
      }
      schema['items'] = {}
      makeSchema(bigObject, schema.items)
    } else if (typeof json === 'object') {
      schema['type'] = 'object'
      schema.properties = {}
      schema.required = Object.keys(json)
      if (!['style'].includes(json)) {
        Object.entries(json).map(([key, value]) => {
          schema.properties[key] = {}
          makeSchema(value, schema.properties[key])
        })
      }
    }
  }
  makeSchema(j, tempSchema)
  return tempSchema
}

export function getUserType() {
  return getLocalStorage().userRole || 'child'
}

export function generateQueryParams(state: any) {
  const {
    id,
    env,
    mode,
    userType,
    configOption,
    loggedInUserAccess,
    selectedUsersList
  } = state
  var url = id ? `${env.value}/${id}` : `${env.value}`
  url = `${url}?sub_type=${configOption.value}&user_role=${userType}`
  if (selectedUsersList.value) {
    url = `${url}&user=${selectedUsersList.value}`
  } else {
    const logged_in_user_email = getRuntimeUserData().email
    url = `${url}&user=${logged_in_user_email}`
  }
  return url
}

export function enumToOptions(en: any): any {
  return Object.entries(en).map(([label, value]) => ({
    label,
    value
  }))
}

export function computeIsAddAllowed({ configOptionValue, userConfig }: any) {
  let tempIsAllowed = false
  tempIsAllowed =
    getUserType() === UserTypes.Developer &&
    configOptionValue === ConfigType['Routes & Menu'] &&
    !userConfig?.length
  return tempIsAllowed
}

export function computeIsUpdateAllowed({ configOptionValue, userConfig }: any) {
  let tempIsAllowed = false
  tempIsAllowed =
    [UserTypes.Developer, UserTypes.Admin].includes(getUserType()) &&
    ConfigType['Routes & Menu'].includes(configOptionValue) &&
    userConfig?.length
  return tempIsAllowed
}

export function computeIsDeleteAllowed({ configOptionValue, userConfig }: any) {
  let tempIsAllowed = false
  tempIsAllowed =
    getUserType() === UserTypes.Developer &&
    ConfigType['Routes & Menu'].includes(configOptionValue) &&
    userConfig?.length
  return tempIsAllowed
}

export function convertToNestedBasedOnSeparator(obj:any,separator:string){
  const result = {};

    for (const [key, value] of Object.entries(obj)) {
        // Split the key by underscores
        const keys = key.split(separator);

        // Reduce the array of keys to build the nested structure
        keys.reduce((acc:any, curr, index) => {
            // Check if we're at the last key in the current path
            if (index === keys.length - 1) {
                acc[curr] = value;
            } else {
                // If the key doesn't exist, create an empty object
                if (!acc[curr]) acc[curr] = {};
                acc = acc[curr];
            }
            return acc;
        }, result);
    }
    return result;
}